export default __webpack_public_path__ + "static/media/physique.6a4d5ff7.svg";